import http from '@core/fetch'

const get = url => query => http(url, { body: query })
const post = url => params =>
  http.post(url, { body: params, ignore: [null, undefined] })

export default {
  // 获取菜单详情
  getMenu: get('/p/wedding/index.php/admin/APIHotelMerchant/menu_info'),
  // 获取菜单模板
  getMenuTemplate: get('/p/wedding/index.php/home/APIMerchant/menuTemplate'),
  // 设置热点
  saveMenu: post('/p/wedding/index.php/admin/APIHotelMerchant/menu')
}
